var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.specComponent)?_c(_vm.specComponent,{tag:"component",attrs:{"specData":_vm.specData},on:{"submit":_vm.onSubmit,"cancel":_vm.onCancel}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }